/*
*
* File JS componente Slider Hero
*
*/


// IMPORT SCSS PER LA COMPILAZIONE
import './home-slider.scss';
//--------------------------------------------------------------------//

//import Swiper from 'swiper/bundle';
import Swiper from 'swiper/bundle';

//import Swiper and modules styles
import 'swiper/css/bundle';

//--------------------------------------------------------------------//

// Init Swiper
const slider = new Swiper('.hero-slider', {
    spaceBetween: 10,
    threshold: 10,
    loop: true,
    effect: 'fade',
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    autoplay: {
        enabled: true,
        delay: 8000,
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    }
});



// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const sliderHero = () => { }

export default sliderHero;

//--------------------------------------------------------------------//

